import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  contact: {
    company: {}
  },
  roles: [],
  deals: [],
  pausedDeals: [],
  closedDeals: [],
  companyDeals: [],
  proposals: [],
  pipeline: {},
  companyPipeline: {},
  notes: []
}

const contactReducer = createReducer(initialState, {
  [ACT.CONTACT_FETCH_SUCCESS](state, action) {
    const {
      contact,
      roles,
      deals,
      lostDeals,
      projectDeals,
      wonDeals,
      closedDeals,
      proposals,
      wonProposals,
      lostProposals,
      pipeline,
      companyDeals,
      companyPipeline
    } = action.payload
    return {
      ...state,
      contact,
      roles,
      deals,
      lostDeals,
      projectDeals,
      wonDeals,
      closedDeals,
      proposals,
      wonProposals,
      lostProposals,
      pipeline,
      companyDeals,
      companyPipeline
    }
  },
  [ACT.ACTIVE_COMPANY_DEALS_FETCH_SUCCESS](state, action) {
    const { companyDeals } = action.payload

    return {
      ...state,
      companyDeals
    }
  },
  [ACT.REMOVE_DEAL_CONTACT_SUCCESS](state, action) {
    const { dealId } = action.payload
    const companyDealsIndex = state.companyDeals.findIndex(d => d.dealId === dealId)

    let newState = state
    if (~companyDealsIndex) {
      newState = update(state, {
        companyDeals: {
          $splice: [[companyDealsIndex, 1]]
        }
      })
    }
    const dealsIndex = state.deals.findIndex(d => d.dealId === dealId)
    if (~dealsIndex) {
      return update(newState, {
        deals: {
          $splice: [[dealsIndex, 1]]
        }
      })
    }
    const pausedDealsindex = state.pausedDeals.findIndex(d => d.dealId === dealId)
    if (~pausedDealsindex) {
      return update(newState, {
        pausedDeals: {
          $splice: [[pausedDealsindex, 1]]
        }
      })
    }
    const closedDealsindex = state.closedDeals.findIndex(d => d.dealId === dealId)
    if (~closedDealsindex) {
      return update(newState, {
        closedDeals: {
          $splice: [[closedDealsindex, 1]]
        }
      })
    }
  },
  [ACT.CONTACT_UPDATE_SUCCESS](state, action) {
    const { contact } = action.payload
    return {
      ...state,
      contact
    }
  },
  [ACT.CONTACT_NOTES_FETCH_SUCCESS](state, action) {
    const { notes } = action.payload

    return update(state, {
      notes: { $set: notes }
    })
  },
  [ACT.CONTACT_ADD_NOTE_SUCCESS](state, action) {
    const { note } = action.payload

    return update(state, {
      notes: { $unshift: [note] }
    })
  },
  [ACT.CONTACT_UPDATE_NOTE_SUCCESS](state, action) {
    const { note, noteId } = action.payload
    const index = state.notes.findIndex(note => note.id === noteId)

    return update(state, {
      notes: {
        [index]: { $set: { ...note } }
      }
    })
  },
  [ACT.CONTACT_DELETE_NOTE_SUCCESS](state, action) {
    const { noteId } = action.payload

    return update(state, {
      notes: { $set: state.notes.filter(n => n.id !== noteId) }
    })
  }
})

export default contactReducer
